import type { EmpresaParametroRequest, EmpresaParametroResponse, EmpresaParametroListResponse } from '@/types/empresa-parametro.model';
import ApiClient from '@/services/api/axios/apiClient';

const EMPRESA_PARAMETRO_ENDPOINT = '/empresa-parametros';

/**
 * Creates a new empresa parametro record
 * @param parametroData - The empresa parametro data to create
 * @returns Promise containing the created empresa parametro
 */
export const createEmpresaParametro = async (
  parametroData: EmpresaParametroRequest
): Promise<EmpresaParametroResponse> => {
  try {
    const response = await ApiClient.post(`${EMPRESA_PARAMETRO_ENDPOINT}`, parametroData);
    return response.data;
  } catch (error) {
    console.error('Error creating empresa parametro:', error);
    throw error;
  }
};

/**
 * Fetches all empresa parametros with optional pagination and filters
 * @param params - Optional query parameters
 * @returns Promise containing the list of empresa parametros
 */
export const getAllEmpresaParametros = async (
  params?: Record<string, string | number>
): Promise<EmpresaParametroListResponse> => {
  try {
    const response = await ApiClient.get(`${EMPRESA_PARAMETRO_ENDPOINT}`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching empresa parametros:', error);
    throw error;
  }
};

/**
 * Fetches an empresa parametro by ID
 * @param id - The empresa parametro ID
 * @returns Promise containing the empresa parametro
 */
export const getEmpresaParametroById = async (id: number): Promise<EmpresaParametroResponse> => {
  try {
    const response = await ApiClient.get(`${EMPRESA_PARAMETRO_ENDPOINT}/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching empresa parametro:', error);
    throw error;
  }
};

/**
 * Updates an existing empresa parametro
 * @param id - The empresa parametro ID
 * @param parametroData - The updated empresa parametro data
 * @returns Promise containing the updated empresa parametro
 */
export const updateEmpresaParametro = async (
  id: number,
  parametroData: Partial<EmpresaParametroRequest>
): Promise<EmpresaParametroResponse> => {
  try {
    const response = await ApiClient.put(`${EMPRESA_PARAMETRO_ENDPOINT}/${id}`, parametroData);
    return response.data;
  } catch (error) {
    console.error('Error updating empresa parametro:', error);
    throw error;
  }
};

/**
 * Deletes an empresa parametro by ID
 * @param id - The empresa parametro ID
 * @returns Promise indicating success or failure
 */
export const deleteEmpresaParametro = async (id: number): Promise<void> => {
  try {
    await ApiClient.delete(`${EMPRESA_PARAMETRO_ENDPOINT}/${id}`);
  } catch (error) {
    console.error('Error deleting empresa parametro:', error);
    throw error;
  }
};